<template>
 
    <div class="card card-container">      
      <!--<img id="profile-img" src="..//assets/christmas.gif" class="profile-img-card" />-->
      <img id="profile-img" src="..//assets/normal.gif" class="profile-img-card" />
      <el-form :rules="rules" :model="loginForm.user" ref="loginForm">     
        <el-form-item label="User Name(e-mail or INCX AD)"  prop="username">
          <el-input v-model="loginForm.user.username" ></el-input>
        </el-form-item>
        
        <el-form-item label="Password"  prop="password">
          <el-input v-model="loginForm.user.password"  type="password" @keyup.enter.native="handleLogin" ></el-input>
        </el-form-item>

        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="handleLogin">Login</el-button>
        </el-form-item>       
      </el-form>
    </div>
</template>

<script>
import User from '../models/user';

export default {
  name: 'Login',
  data() {
    return {      
      loginForm:{
        user: new User('', ''),
      },      
      rules: {
        username: [
          { required: true, message: '欄位不得為空', trigger: 'blur'}
          //{ type: 'email', message: 'Please input correct username address', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: '欄位不得為空', trigger: 'blur' },
          { min: 6, message: '長度需6碼以上', trigge:  'blur' }
        ]
      },
    };
  },  
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/');
      location.reload();
    }
  },
  methods: { 

    handleLogin() {     
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      this.$refs['loginForm'].validate((isValid) => {
        if (!isValid) {
          loading.close();
          return;
        }
        if (this.loginForm.user.username && this.loginForm.user.password) {
  
          try{   
            this.loginForm.user.username = this.loginForm.user.username.toLowerCase()   
            this.$store.dispatch('auth/login', this.loginForm.user).then(
            () => {             
              this.$router.push('/');
              location.reload();
              loading.close();
            },
            error => {
              loading.close();
              this.$message.error({message: this.$i18n.t('msg.authenticationFailed'), duration: 2000});
            }
          );
          }catch(e){          
            loading.close();
            this.$message.error({message: this.$i18n.t('msg.authenticationFailed'), duration: 2000});
          }
        }
      });
    }
  }
};
</script>

<style scoped>


.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #fff;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  -moz-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  /* width: 328px; christmas */
  /*height: 80px;  christmas */
  width: 110px;/*  normal */
  height: 50px;  /*normal */
  margin: 0 auto 10px;
  display: block;
  /* -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
   border-radius: 50%; */
}
</style>